import AjouterTravailleur from '@/views/mdt/ajouterTravailleur'
import moment from 'moment';
import $ from 'jquery';

export default {
    name: 'travailleurs',
    components: { AjouterTravailleur },
    props: [],
    data() {
        return {
            fields: [{ key: 'index', label: 'N° matri.' }, { key: 'nom', label: 'Nom et prenoms' },
                'sexe',
                'poste',

                {
                    key: 'date_embauche',
                    label: 'Date d\'embauche'
                },
                {
                    key: 'duree_poste',
                    label: 'Durée au poste'
                },
                {
                    key: 'departement',
                    label: 'Département'
                },
                'actions'
            ],
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,
            files: [],
            import_loading: false,
            btn_disable: false,

            file_error: false
        }
    },
    computed: {
        rows() {
            return this.travailleurs.length;
        },
        travailleurs() {
            return this.$store.getters['employes']
        }

    },
    mounted() {
        this.$store.dispatch('listeEmployes', this.$route.params.id).then(() => console.log('listezaza', this.travailleurs))
    },
    methods: {
        handleFilesUpload() {

            let uploadedFiles = this.$refs.files.files;
            /*
              Adds the uploaded file to the files array
            */
            this.files = []
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
        },


        importEmploye() {
            this.import_loading = true
            this.btn_disable = true
            let formData = new FormData();
            $('.err-msg').fadeOut()

            let err = 0

            if (this.files.length == 0) {
                err++
            }

            if (err == 0) {
                formData.append('file', this.files[0]);

                this.$store.dispatch("importEmploye", { 'id': this.$route.params.id, 'data': formData }).then((response) => {
                    console.log("RESPONSE IMPORT : ",response)
                    this.$refs.close_modal.click()

                    this.successMsg("Importation des employés avec succès");
                    this.import_loading = false
                    this.btn_disable = false
                    // après le rendu sur la page, faire disparaitre le modal
                    // this.files = []

                }, error => {
                    if (error.response) {
                        // this.doErrorMsg("Erreur d'enregistrement")
                        console.log("Erreur Import")
                        this.import_loading = false
                        this.btn_disable = false
                    }

                });
            } else {
                // TODO::: Afficher un message informant l'utilisateur de choisir un fichier
                $('.err-msg').fadeIn(500)
                this.import_loading = false
                this.btn_disable = false
            }
        },

        dureePoste(dateEmbau) {
            let objDebut = moment(new Date(dateEmbau));
            let objFin = moment(new Date())

            let diff = objFin.diff(objDebut, 'year')
            var months = objFin.diff(objDebut, 'months');
            objFin.add(months, 'months')
            var days = objFin.diff(objDebut, 'days');

            return { 'years': diff, 'months': months % 12, 'days': days % 30 };
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },
    }
}